import DraggableRowsTable from './DraggableRowsTable';

export default DraggableRowsTable;
